import { useState } from 'react'
import { Download, Share, X } from 'lucide-react'
import { useIsMobileTablet } from '../../hooks/useIsMobileTablet'
import { usePwaInstall } from '../../utils/pwaInstall'
import './InstallAppBanner.css'

const DISMISS_KEY = 'wfmed-pwa-install-dismissed'

function InstallAppBanner() {
  const isMobile = useIsMobileTablet()
  const { canInstall, showIosHint, promptInstall } = usePwaInstall()
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1'
    } catch {
      return false
    }
  })

  if (!isMobile || dismissed || (!canInstall && !showIosHint)) return null

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, '1')
    } catch {
      /* ignore */
    }
    setDismissed(true)
  }

  const install = async () => {
    const accepted = await promptInstall()
    if (accepted) dismiss()
  }

  return (
    <div className="pwa-install-banner" role="region" aria-label="Instalar aplicativo">
      {showIosHint && !canInstall ? <Share size={18} aria-hidden="true" /> : <Download size={18} aria-hidden="true" />}
      <p>
        {showIosHint && !canInstall
          ? 'Para baixar o ERP no iPhone ou iPad, toque em Compartilhar e escolha Adicionar à Tela de Início.'
          : 'Instale o ERP neste aparelho para abrir como um aplicativo.'}
      </p>
      {canInstall && (
        <button type="button" className="pwa-install-banner__action" onClick={install}>
          Instalar
        </button>
      )}
      <button type="button" className="pwa-install-banner__close" onClick={dismiss} aria-label="Fechar">
        <X size={16} />
      </button>
    </div>
  )
}

export default InstallAppBanner
